import { type ChangeEvent, type FC, type MouseEvent, type ReactNode, useState } from 'react';
import classNames from 'classnames';
// Import UI Components
import { Button, Switcher } from '@geneui/components';
// Import Styles
import styles from './customerJourneyVisualizationToggleSection.module.scss';

interface Props {
    // switcher label and the short description shown next to it
    label: string;
    description: string;
    isChecked: boolean;
    onChange: (isChecked: boolean) => void;
    className?: string;
    contentClassName?: string;
    children?: ReactNode;
}

const CustomerJourneyVisualizationToggleSection: FC<Props> = (props) => {
    const { label, description, isChecked, onChange, className, contentClassName, children } = props;

    const [isExpanded, setIsExpanded] = useState(true);

    const switcherChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    const expandClickHandler = () => {
        isChecked && setIsExpanded((prev) => !prev);
    };

    const switcherClickHandler = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    return (
        <div className={classNames(styles.toggleSection, className)}>
            <div
                className={classNames(styles.toggleSectionHeader, {
                    [styles.toggleSectionHeaderExpandable]: isChecked,
                })}
                onClick={expandClickHandler}
            >
                <div onClick={switcherClickHandler}>
                    <Switcher label={label} checked={isChecked} onChange={switcherChangeHandler} />
                </div>
                <span className={styles.toggleSectionDescription}>{description}</span>
                {isChecked && (
                    <Button
                        className={styles.toggleSectionExpandButton}
                        icon={isExpanded ? 'bc-icon-arrow-up' : 'bc-icon-arrow-down'}
                        appearance="minimal"
                    />
                )}
            </div>
            {isChecked && (
                <div
                    className={classNames(styles.toggleSectionContent, contentClassName, {
                        [styles.toggleSectionContentCollapsed]: !isExpanded,
                    })}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

CustomerJourneyVisualizationToggleSection.displayName = 'CustomerJourneyVisualizationToggleSection';

export default CustomerJourneyVisualizationToggleSection;
